import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BookSessionContext } from "@context/BookSessionContext";

const PaymentStatus = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { setError } = useContext(BookSessionContext);
    const errors = queryParams.get("errors");

    useEffect(() => {
        let timer;
        if (errors && errors.length > 0) {
            setError(errors);
            timer = setTimeout(() => {
                setError(null);
            }, 4000);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [errors, setError]);
    return null;
};

export default PaymentStatus;
